import { jsx as _jsx } from "react/jsx-runtime";
import * as Sentry from "@sentry/react";
import { default as posthog } from "posthog-js";
import { useFeatureFlagEnabled as usePostHogFeatureFlagEnabled } from "posthog-js/react";
import { createContext, useContext, useEffect, useMemo, } from "react";
import { useLocation } from "react-router";
import { isProd } from "./lib";
const posthogToken = typeof window !== "undefined"
    ? process.env.POSTHOG_PROJECT_TOKEN || window.posthogToken
    : undefined;
const posthogEnabled = process.env.POSTHOG_ENABLED === "true";
if (posthogEnabled && posthogToken) {
    posthog.init(posthogToken, {
        api_host: process.env.POSTHOG_PROXY_URL || "https://eu.i.posthog.com",
        ui_host: "https://eu.posthog.com",
        capture_pageview: false,
        session_recording: {
            strictMinimumDuration: true,
        },
    });
}
if (isProd && process.env.SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        ignoreErrors: [
            "TypeError: Failed to fetch",
            "TypeError: NetworkError when attempting to fetch resource.",
            "TypeError: Cancelled",
            "TypeError: avbruten",
            "ResizeObserver loop limit exceeded",
            "ResizeObserver loop completed with undelivered notifications.",
        ],
        integrations: [
            Sentry.browserTracingIntegration(),
            posthog.sentryIntegration({
                organization: "sveriges-schackforbund",
                projectId: Number(process.env.SENTRY_DSN.split("/").pop()),
            }),
        ],
        tracesSampleRate: 1.0,
        environment: process.env.MODE,
        release: process.env.GITHUB_SHA,
        enabled: process.env.MODE !== "development",
    });
}
const TrackContext = createContext({
    page: () => { },
    identify: () => { },
    reset: () => { },
});
function page() {
    posthog.capture("$pageview");
}
function identify(id) {
    posthog.identify(id);
    Sentry.setUser({ id });
}
function reset() {
    posthog.reset();
    Sentry.setUser(null);
}
export const TrackProvider = (props) => {
    return (_jsx(TrackContext.Provider, { value: useMemo(() => ({ identify, page, reset, posthog }), []), ...props }));
};
export const useTrack = () => useContext(TrackContext);
export const useFeatureFlagEnabled = (flag, defaultValue = !posthogEnabled) => usePostHogFeatureFlagEnabled(flag, defaultValue);
export const useTrackPageChange = () => {
    const location = useLocation();
    const { page } = useTrack();
    // biome-ignore lint/correctness/useExhaustiveDependencies: Used as observer
    useEffect(() => {
        page();
    }, [location]);
};
//# sourceMappingURL=TrackProvider.js.map